import { useContext, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { useSnackbar } from 'fronton-react';
import { DataContext } from 'entries/common/widgets/context';
import { setConfigurationIdCookie } from 'pages/project-configuration/helpers/set-configuration-id-cookie';
import { SNACKBARS_DICTIONARY, TSnackbarDictionaryKeys } from 'pages/common/components/Snackbar';
import { ENDPOINTS, userProjectConfigurationCookieNames } from 'pages/project-configuration/const';
import { complimentaryProductsState, useCalculationState } from 'pages/calculation/store/calculation';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { SAVED_CONFIGURATION_LAMINATE_COOKIE } from 'pages/common/const';
import { ProjectStatuses } from 'pages/common/types';
import { getDomain } from 'utils/get-domain.helper';
import { deleteCookie, getCookie, setCookie } from 'utils/cookie.helper';
import { configurateGeneralItems } from '../helpers/configurate-general-items.helper';

export const useToggleProjectStatus = () => {
  const [isProjectSaved, setIsProjectSaved] = useState(!!getCookie(SAVED_CONFIGURATION_LAMINATE_COOKIE));
  const { calculationFormState, totalAmount } = useCalculationState();
  const complimentaryProducts = useRecoilValue(complimentaryProductsState);
  const dimensions = useRecoilValue(dimensionsAtom);
  const configurationId = getCookie(userProjectConfigurationCookieNames.LAMINATE);
  const domain = getDomain();
  const data = useContext(DataContext);

  const { addSnack } = useSnackbar();

  const saveProjectToShoppingList = async () => {
    try {
      await data!.api.patch(ENDPOINTS.EDIT_CONFIGURATION(configurationId as string), {
        projectStatus: ProjectStatuses.SAVED,
        regionId: data?.regionId,
        approximateTotalAmount: totalAmount,
        generalItems: configurateGeneralItems({
          data,
          dimensions,
          complimentaryProducts,
          count: Number(calculationFormState.count),
        }),
      });

      setCookie(SAVED_CONFIGURATION_LAMINATE_COOKIE, 'true', {
        path: '/',
        domain,
        expires: new Date(new Date().getFullYear() + 1, 12, 31),
      });
      deleteCookie(userProjectConfigurationCookieNames.LAMINATE);

      setIsProjectSaved(true);
      addSnack(SNACKBARS_DICTIONARY[TSnackbarDictionaryKeys.ADD_TO_SHOPPING_LIST_SUCCESS]);
    } catch {
      setIsProjectSaved(false);
      addSnack(SNACKBARS_DICTIONARY[TSnackbarDictionaryKeys.ADD_TO_SHOPPING_LIST_ERROR]);
    }
  };

  const removeProjectFromShoppingList = async () => {
    try {
      await data!.api.patch(ENDPOINTS.EDIT_CONFIGURATION(configurationId as string), {
        projectStatus: ProjectStatuses.NEW,
      });

      if (configurationId) {
        setConfigurationIdCookie({
          projectConfigurationId: configurationId,
          projectConfigurationCookieName: userProjectConfigurationCookieNames.LAMINATE,
        });
      }

      setIsProjectSaved(false);
    } catch {
      setIsProjectSaved(true);
    }
  };

  return {
    isProjectSaved,
    saveProjectToShoppingList,
    removeProjectFromShoppingList,
  };
};
